import * as React from "react";
import { forwardRef } from "react";
const SvgChevron = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 25, height: 25, viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.35348 20.3535L0.646371 19.6464L7.79282 12.5L0.64637 5.35352L1.35348 4.64641L9.20703 12.5L1.35348 20.3535Z", fill: "black" }));
const ForwardRef = forwardRef(SvgChevron);
export { ForwardRef as ReactComponent };
